var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { oigBoardName } from '../../../../../backend/constants';
import { licenseStatuses } from '../../../../../backend/extraTypes';
import { getOccupationAllAssignedCredentialsFormValidation } from '../../../../../ui/features/forms/utils';
import { PublicDataClient } from '@juvare/platform-sdk-js/PublicDataClient';
export function buildCredentialingSubFormProviders(appName, t, getOccupationFormConfigPlatformFn, userState) {
    var _a;
    if (userState && !((_a = userState === null || userState === void 0 ? void 0 : userState.credentialing) === null || _a === void 0 ? void 0 : _a.featureFlags.includes('occupations'))) {
        return [];
    }
    return [
        buildSubFormProvider(appName, 'occupationAllAssignedCredentials', 'Occupation (All Assigned Credentials)', (params) => __awaiter(this, void 0, void 0, function* () {
            if (typeof params === 'string') {
                const subForm = { children: [] };
                const credentialFormConfigs = (yield getOccupationFormConfigPlatformFn({
                    occupationId: params,
                }));
                for (const credentialFormConfig of credentialFormConfigs) {
                    if (credentialFormConfig.form.children &&
                        credentialFormConfig.form.children.length > 0 &&
                        credentialFormConfig.name !== oigBoardName) {
                        let credentialPanelHidden;
                        let credentialPanelClearDataOnHide;
                        if (credentialFormConfig.form.children.length === 1 &&
                            credentialFormConfig.form.children[0].type === 'form.panel') {
                            credentialPanelHidden = credentialFormConfig.form.children[0].hidden;
                            credentialPanelClearDataOnHide = credentialFormConfig.form.children[0].clearDataOnHide;
                            delete credentialFormConfig.form.children[0].hidden;
                            delete credentialFormConfig.form.children[0].clearDataOnHide;
                        }
                        subForm.children.push({
                            type: 'form.panel',
                            key: credentialFormConfig.credentialId,
                            hidden: credentialPanelHidden,
                            clearDataOnHide: credentialPanelClearDataOnHide,
                            children: [
                                {
                                    type: 'form.modalPanelList',
                                    validate: getOccupationAllAssignedCredentialsFormValidation(credentialFormConfig.name, t),
                                    key: 'licenses',
                                    label: credentialFormConfig.name,
                                    addButtonLabel: 'Add ' + credentialFormConfig.name,
                                    modal: {
                                        maxWidth: 'md',
                                        fullWidth: true,
                                        children: [
                                            {
                                                type: 'form.panel',
                                                key: '!credentialFormModalPanel',
                                                children: [
                                                    ...createStatusWidget(credentialFormConfig, t),
                                                    ...credentialFormConfig.form.children,
                                                ],
                                            },
                                        ],
                                    },
                                    panel: {
                                        alert: {
                                            custom: (value) => {
                                                switch (value.status) {
                                                    case 'missingFields': {
                                                        if (value.currentlyPossess === 'No') {
                                                            return {
                                                                severity: 'warning',
                                                                message: t('licenseStatuses.notChecked'),
                                                            };
                                                        }
                                                        return {
                                                            severity: 'warning',
                                                            message: t('licenseStatuses.missingFields'),
                                                        };
                                                    }
                                                    case 'readyToVerify':
                                                        return {
                                                            severity: 'info',
                                                            message: t('licenseStatuses.readyToVerify'),
                                                        };
                                                    case 'pending':
                                                        return {
                                                            severity: 'info',
                                                            message: t('licenseStatuses.pending'),
                                                        };
                                                    case 'verified':
                                                        return {
                                                            severity: 'success',
                                                            message: t('licenseStatuses.verified'),
                                                        };
                                                    case 'verifiedExpirationUpdated':
                                                        return {
                                                            severity: 'success',
                                                            message: t('licenseStatuses.verifiedExpirationUpdated'),
                                                        };
                                                    case 'notVerified':
                                                        return {
                                                            severity: 'error',
                                                            message: t('licenseStatuses.notVerified'),
                                                        };
                                                    case 'inactive':
                                                        return {
                                                            severity: 'error',
                                                            message: t('licenseStatuses.inactive'),
                                                        };
                                                    case 'cvoExpired':
                                                        return {
                                                            severity: 'error',
                                                            message: t('licenseStatuses.cvoExpired'),
                                                        };
                                                    case 'noMatchFound':
                                                        return {
                                                            severity: 'error',
                                                            message: t('licenseStatuses.noMatchFound'),
                                                        };
                                                    case 'multipleMatchesFound':
                                                        return {
                                                            severity: 'error',
                                                            message: t('licenseStatuses.multipleMatchesFound'),
                                                        };
                                                    case 'notChecked':
                                                        return {
                                                            severity: 'warning',
                                                            message: t('licenseStatuses.notChecked'),
                                                        };
                                                    case 'expired':
                                                        return {
                                                            severity: 'error',
                                                            message: t('licenseStatuses.expired'),
                                                        };
                                                    case 'outOfState':
                                                        return {
                                                            severity: 'error',
                                                            message: t('licenseStatuses.outOfState'),
                                                        };
                                                }
                                                return undefined;
                                            },
                                        },
                                        children: [
                                            {
                                                type: 'form.tableView',
                                                component: '^/!credentialFormModalPanel',
                                            },
                                        ],
                                    },
                                    style: {
                                        variant: 'level3',
                                    },
                                    autoSave: true,
                                },
                            ],
                        });
                    }
                }
                return subForm;
            }
            else {
                return { children: [] };
            }
        })),
        buildSubFormProvider(appName, 'occupationGroup', 'Occupation Group'),
        buildSubFormProvider(appName, 'occupationCredential', 'Occupation Credential'),
    ];
}
function buildSubFormProvider(appName, classifierName, label, getSubForm) {
    return {
        type: 'classifier.' + classifierName,
        label: label,
        // TODO remove disableCache after CUI-138 fixed
        disableCache: true,
        getSubForm: getSubForm
            ? getSubForm
            : (params) => {
                if (typeof params === 'string') {
                    const client = new PublicDataClient(appName);
                    console.log('classifier-' + classifierName);
                    return client
                        .publicDataGetObject('classifier-' + classifierName)
                        .then((result) => {
                        var _a, _b;
                        const classifier = result.find((item) => item.value === params);
                        return { children: (_b = (_a = classifier === null || classifier === void 0 ? void 0 : classifier.form) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : [] };
                    });
                }
                else {
                    return Promise.resolve({ children: [] });
                }
            },
    };
}
const allLicenseStatusValues = (t) => licenseStatuses.map((value) => ({ value, label: t(`licenseStatuses.${value}`) }));
const manualLicenseStatusValues = (t) => buildManualStatusesList(allLicenseStatusValues, t);
function buildManualStatusesList(allLicenseStatuses, t) {
    const statusOrder = ['notChecked', 'verified', 'notVerified', 'expired'];
    const manualStatuses = allLicenseStatuses(t).filter((value) => statusOrder.includes(value.value));
    return manualStatuses.sort((a, b) => statusOrder.indexOf(a.value) - statusOrder.indexOf(b.value));
}
function createStatusWidget(config, t) {
    const statusWidget = {
        type: 'form.select',
        key: 'status',
        label: 'Status',
        values: [],
    };
    if (config.jasBoard) {
        return [Object.assign(Object.assign({}, statusWidget), { values: allLicenseStatusValues(t), disabled: true, rules: ['automaticLicenseStatusPermission'] })];
    }
    else {
        return [
            Object.assign(Object.assign({}, statusWidget), { values: manualLicenseStatusValues(t), rules: ['manualLicenseStatusPermission'], defaultValue: 'notChecked', validate: { required: true } }),
        ];
    }
}
